import React from 'react';

export default function SimpleMixerIcon({
  width = 64,
  height = 119,
  startColor = '#000000',
  midColor = '#ffffff',
  endColor = '#000000'
}) {
  const id = Math.random().toString(36).slice(2, 9);
  return (
    <svg width={width} height={height} viewBox="0 0 538 999" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <filter id={`fp-shadow-${id}`} x="-20%" y="-20%" width="140%" height="140%">
          <feGaussianBlur in="SourceAlpha" stdDeviation="2.5"/>
          <feOffset dx="0" dy="3" result="offsetblur"/>
          <feComponentTransfer><feFuncA type="linear" slope="0.45"/></feComponentTransfer>
          <feMerge><feMergeNode/><feMergeNode in="SourceGraphic"/></feMerge>
        </filter>
        <radialGradient id={`fp-shine-${id}`} cx="35%" cy="22%" r="65%">
          <stop offset="0%" stopColor="rgba(255,255,255,0.28)"/>
          <stop offset="55%" stopColor="rgba(255,255,255,0.06)"/>
          <stop offset="100%" stopColor="rgba(255,255,255,0)"/>
        </radialGradient>
      </defs>
      <g filter={`url(#fp-shadow-${id})`}>
      <path style={{fill: "#7f7f7f", stroke: "#4c4c4c", strokeWidth: "2"}} d="M265,901 l-265,7 91,-56 356,84 91,-49 -259,0 21,112 -132,-49 97,-49z" /><path style={{fill: "#000", stroke: "#4c4c4c", strokeWidth: "2"}} d="M258,342 l35,0 0,559 -35,0 0,-559z" /><path style={{fill: "#7f7f7f", stroke: "#4c4c4c", strokeWidth: "2"}} d="M146,39 l0,284 2,4 3,4 3,4 5,4 6,3 6,3 8,3 8,3 9,3 9,2 11,2 10,2 12,1 12,1 12,1 12,0 13,0 12,-1 11,-1 12,-1 10,-2 10,-2 10,-2 9,-2 8,-3 7,-3 6,-3 5,-3 5,-3 3,-3 2,-4 1,-3 0,-292 -2,-3 -2,-3 -3,-4 -5,-3 -6,-3 -6,-3 -7,-3 -8,-2 -9,-3 -9,-2 -10,-2 -11,-1 -10,-2 -12,-1 -12,0 -12,0 -12,0 -12,0 -12,1 -11,2 -10,1 -10,2 -10,2 -9,3 -8,3 -8,3 -7,3 -5,4 -5,3 -4,4 -3,4 -2,4z" /><path style={{fill: "none", stroke: "#4c4c4c", strokeWidth: "2"}} d="M398,44 l-1,4 -2,4 -4,4 -5,3 -5,4 -6,3 -7,3 -8,3 -9,3 -10,2 -10,2 -10,1 -11,2 -12,1 -12,1 -12,0 -13,0 -12,-1 -12,-1 -12,-2 -10,-1 -11,-3 -9,-2 -9,-3 -8,-3 -7,-3 -6,-3 -6,-4 -4,-4 -3,-4 -2,-4 -1,-4 0,-1 0,0 0,-1 0,0" /><path style={{fill: "#fff", stroke: "#fff", strokeWidth: "2"}} d="M335,97 l28,0 0,231 -28,0 0,-231z" /><path style={{fill: "#000", stroke: "#4c4c4c", strokeWidth: "2"}} d="M195,97 l14,0 0,231 -14,0 0,-231z" /><path style={{fill: "#7f7f7f", stroke: "#4c4c4c", strokeWidth: "2"}} d="M146,195 l-62,0 0,-111 62,0 0,111z" />
    
      </g>
      <rect x="0" y="0" width="538" height="999" fill={`url(#fp-shine-${id})`} style={{pointerEvents:"none"}}/>
    </svg>
  );
}
